/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { DefaultProjectorFn, resultMemoize } from '@ngrx/store';

export class SelectorFunctions {
    public static shallowCompare<T>(obj1: T, obj2: T) {
        return obj1 && obj2 && Object.keys(obj1).length === Object.keys(obj2).length && Object.keys(obj1).every((key) => obj1[key as keyof T] === obj2[key as keyof T]);
    }

    public static shallowArrayCompare<T>(array1: T[], array2: T[]) {
        return array1.length === array2.length && array1?.every((item1) => array2?.some((item2) => SelectorFunctions.shallowCompare(item1, item2)));
    }

    public static shallowObjectMemoize<T>(projectorFn: DefaultProjectorFn<T>) {
        return resultMemoize(projectorFn, SelectorFunctions.shallowCompare);
    }

    public static shallowObjectArrayMemoize<T>(projectorFn: DefaultProjectorFn<T[]>) {
        return resultMemoize(projectorFn, SelectorFunctions.shallowArrayCompare);
    }
}
